<div class="cancellation-reasons-wrapper" #modalElement>
  <div class="title-wrapper">
    <h4>{{ data.title }}</h4>
    <button (click)="closeModal()" class="icon-button">
      <i class="fa-regular fa-xmark fa-xl"></i>
    </button>
  </div>

  <div class="cancellation-reasons-radios">
    <div *ngFor="let reason of cancellationReasons">
      <label
        class="answer-box"
        [class.selected]="cancellationReasonSelected === reason"
        tabindex="0"
        (keydown)="onKeyDown($event, reason)"
        (click)="selectReason(reason)"
      >
        <input
          type="radio"
          name="reason"
          [value]="reason"
          [checked]="cancellationReasonSelected === reason"
          required
          (change)="showError = false"
          tabindex="-1"
        />
        <p>{{ reason }}</p>
      </label>
    </div>
  </div>

  <div
    class="other-reason-input"
    *ngIf="cancellationReasonSelected === 'Other'"
  >
    <textarea
      placeholder="Tell us why you're cancelling."
      maxlength="250"
      [(ngModel)]="otherReason"
      (input)="showError = false"
    ></textarea>
    <span class="char-count"
      ><p>{{ otherReason?.length || 0 }}/250</p></span
    >
  </div>

  <div class="are-you-sure-message">
    <h5>{{ data.subTitle }}</h5>
    <p class="body">
      {{ data.body }}
    </p>
  </div>

  <div class="different-date-message" *ngIf="data.hasAmendableBooking">
    <h5>Need a different date?</h5>
    <p class="body">
      Use the ‘Change the date’ option to move your engineer’s visit.
    </p>
  </div>

  <div class="error-message" *ngIf="showError">
    <dgx-components-icon name="circle-exclamation"> </dgx-components-icon>
    <ng-container
      *ngIf="cancellationReasonSelected !== 'Other'; else otherReasonError"
    >
      <p class="body">{{ data.errorMessage }}</p>
    </ng-container>
    <ng-template #otherReasonError>
      <p class="body">{{ data.errorMessageOther }}</p>
    </ng-template>
  </div>

  <div class="button-actions">
    <ng-container *ngFor="let btn of data.buttons">
      <dgx-components-button
        [variant]="btn.variant"
        (click)="onButtonClick(btn.action)"
      >
        {{ btn.text }}
      </dgx-components-button>
    </ng-container>
  </div>
</div>
